import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '../../interfaces/user.interface';
import { PMEUserService } from '../services/pme-user.service';

@Pipe({
  name: 'canDelete',
  standalone: true
})
export class CanDeletePipe implements PipeTransform {
  constructor(private pmeUserService: PMEUserService) {}

  // biome-ignore lint/suspicious/noExplicitAny: Allowing as currentItem could be many different types
  transform(currentItem: any): boolean {
    const currentUser = this.pmeUserService.currentUser;

    return (
      (!currentItem.status || currentItem.status === 'active') &&
      (currentUser?.roles?.includes(UserRole.PMEDataIntegrity) ||
        (currentItem.createdby === currentUser?.email && !currentItem['approved']))
    );
  }
}
